import { AkebonoCoreModule } from '@akebono/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TranslateModule } from '@ngx-translate/core';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzModalModule } from 'ng-zorro-antd/modal';

import { AudioTranslationSpeedService } from './services/audio-translation-speed.service';
import { LotTranslationsFeedbackService } from './services/lot-translations-feedback.service';
import { LotTranslationsComponent } from './lot-translations.component';
import { LotTranslationsFeedbackComponent } from './components/lot-translations-feedback/lot-translations-feedback.component';
import { LotTranslationsFeedbackModalComponent } from './components/lot-translations-feedback-modal/lot-translations-feedback-modal.component';

@NgModule({
  declarations: [
    LotTranslationsComponent,
    LotTranslationsFeedbackComponent,
    LotTranslationsFeedbackModalComponent,
  ],
  imports: [
    CommonModule,
    BrowserModule,
    TranslateModule,
    BrowserAnimationsModule,
    NzCollapseModule,
    NzAlertModule,
    AkebonoCoreModule,
    NzTagModule,
    NzIconModule,
    NzButtonModule,
    NzGridModule,
    NzInputModule,
    NzModalModule,
    FormsModule,
    ReactiveFormsModule,
    NzFormModule,
    NzSpinModule,
  ],
  providers: [AudioTranslationSpeedService, LotTranslationsFeedbackService],
  exports: [LotTranslationsComponent],
})
export class LotTranslationsModule {}
